<template>
    <div class="contact-list-import-upload">

        <ContactImportUpload
            :override-import-type="'contact-list'"
            :pageCopy="page_copy"
            :fieldDefinitions="field_definitions"
            :previewConfig="preview_config"
            :targetListName="target_list_name"
        />
    </div>
</template>

<script>
import ContactImportUpload from '@/components/contacts/contact-import-component.vue';

export default {
    name: 'ContactListImportUpload',
    components: { ContactImportUpload },
    data() {
        return {
            target_list_name: null
        };
    },
    mounted() {
        if (!this.$route.query.list_id && !this.$route.params.import_id) {
            this.$rc.alert('List ID is required for new contact list imports', 'error');
            this.$router.push(`/app/contact-lists/${this.$route.params.organization_id}`);
            return;
        }

        if (this.$route.query.list_id) {
            this.loadListLabel(this.$route.query.list_id);
        }
        else if(this.$route.params.import_id)
        {
            //Load from the metadata otherwise
            this.loadListLabelFromImportMetadata(this.$route.params.import_id);
        }
        
    },
    methods: {
        loadListLabelFromImportMetadata(import_id) {
            if (!import_id) {
                return;
            }
            //Use the view import meta data summary view to get the list name
            this.$rc.rest({
                spinner: false, 
                endpoint: 'LIST: /api/v1/imports/contact-list/search/'+this.$route.params.organization_id,
                params: {
                    start: 0,
                    count: 1,
                    full_text: import_id
                },
                on_success: (data) => {
                    if(data.results.length == 0)
                    {
                        this.target_list_name = 'Contact List';
                        return;
                    }
                    this.target_list_name = data.results[0].target_list_names ? data.results[0].target_list_names.replace(/\|/g, ', ') : '';
                },
                on_error: (error) => {
                    this.target_list_name = null;
                    this.$rc.alert(`Unable to load list label: ${error}`, 'error');
                }
            });
        },
        loadListLabel(list_id) {
            if (!list_id) {
                return;
            }
            this.$rc.rest({
                spinner: false,
                endpoint: 'GET: /api/v1/lists/:list_id',
                params: { list_id },
                on_success: (data) => {
                    this.target_list_name = data.list_external_label || data.list_internal_label || 'Contact List';
                },
                on_error: () => {
                    this.target_list_name = null;
                }
            });
        }
    },
    computed: {

        page_copy() {
            return {
                pageTitle: 'Import Contacts to List',
                historyRouteName: 'search-contact-list-imports',
                instructionsText: 'Use this tool to import contact records from an Excel file. The contact list import process allows you to bulk upload customer contact information and add them to specific contact lists.',
                uploadProgressDescription: 'Please wait while we upload and process your contact list file.',
                executionProgressTitle: 'Importing Contacts to List',
                executionProgressDescription: 'Please wait while we import your contacts to the list. This can take several minutes.',
                executionStatusMessage: 'Working...',
                completionTitle: 'Contact List Import Complete!',
                completionDescription: 'Your contacts have been successfully imported to the list.'
            };
        },
        field_definitions() {
            return {
                requiredFields: [
                    { key: 'phone_number', label: 'Phone Number', description: 'Phone number(s) for the contact - you can select multiple columns', multiple: true, required: true, hint: 'Select one or more columns containing phone numbers' },
                    { key: 'first_name', label: 'First Name', description: 'Contact\'s first name', multiple: false, required: true, hint: 'Select the column containing first names' },
                    { key: 'last_name', label: 'Last Name', description: 'Contact\'s last name', multiple: false, required: true, hint: 'Select the column containing last names' }
                ],
                optionalFields: [
                    { key: 'email', label: 'Email', description: 'Contact\'s email address', multiple: false, required: false, hint: 'Select the column containing email addresses' },
                    { key: 'birthdate', label: 'Birthdate', description: 'Contact\'s birthdate', multiple: false, required: false, hint: 'Select the column containing birthdates (supports MM/DD/YYYY, MM/DD/YY, or YYYY-MM-DD formats)' },
                    { key: 'notes', label: 'Notes', description: 'Contact\'s Notes', multiple: false, required: false, hint: 'Select the column containing notes about the contact' }
                ]
            };
        },
        preview_config() {
            return {
                tableHeaders: [
                    { text: 'Include', value: 'select', align: 'center', sortable: false, alwaysShow: true },
                    { text: 'Row', value: 'row_number', width: '50px', align: 'center', alwaysShow: true },
                    { text: 'Contact Status', value: 'import_status',  align: 'center', alwaysShow: true },
                    { text: 'List Membership Status', value: 'rc_add_to_membership_status', align: 'center', alwaysShow: true },
                    { text: 'Phone Number', value: 'rc_phone_number', width: '180px', align: 'left', alwaysShow: true },
                    { text: 'First Name', value: 'rc_first_name' },
                    { text: 'Last Name', value: 'rc_last_name' },
                    { text: 'Email', value: 'rc_email' },
                    { text: 'Birthdate', value: 'rc_birthdate' },
                    { text: 'Notes', value: 'rc_notes' },
                    { text: 'Phone Validation Status', value: 'rc_validation_status' },
                    { text: 'System Notes', value: 'rc_system_notes' },
                    { text: 'Errors', value: 'errors', alwaysShow: true }
                ],

                customColumns: [
                    { key: 'select', type: 'custom' },
                    { key: 'rc_add_to_membership_status', type: 'enum' }
                ]
            };
        }
    }
};
</script>

<style scoped>
.contact-list-import-upload {
    position: relative;
}
</style>
